import React from 'react'
import {StripeBG} from '../components'
import {Navbar, Footer} from '../components/marketing'
import * as Paths from '../constants/Paths'
import {seoPageChange} from '../utils'

class Pricing extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {seoPageChange()}

  render() {
    return (
      <div className="PricingPage">
        <StripeBG bg2={"white"} />
        <Navbar className="grid-restrain "/>
        <div className="s10 grid-restrain ">
        <div className="grid-row h-align feature-table full-8">
          <div className="grid-item grid-row card sr4 full-s5">
            <div className="grid-item feature-plan grid-row grid-column">
              <div className="title">Free</div>
              <div className="core">+ SnapTest Features</div>
              <div className="core">+ All SnapTest Generators</div>
              <div className="features">
                <div className="new">+ Local mode</div>
                <div className="new">+ Run Configs</div>
                <div className="new">+ Results</div>
                <div className="new">+ Private mode</div>
                <div className="new">+ Draft mode</div>
                <div className="new construct">+ Data Driven Testing</div>
                <div className="new construct">+ Form, SEO, Spelling Scans</div>
              </div>
              <div className="grid-item"></div>
              <div className="price">
                <div>$0/month</div>
                <a className="pt-button pt-intent-primary3 pt-large" href="https://chrome.google.com/webstore/detail/snaptest/aeofjocnhdlleichkjbaibdbicpcddhp?hl=en-US" >
                  + Download
                </a>
              </div>
            </div>
          </div>
          <div className="grid-item grid-row card sr4 full-s5">
            <div className="grid-item feature-plan grid-row grid-column premium">
              <div className="title">Cloud</div>
              <div className="core">+ SnapTest Cloud Features</div>
              <div className="core">+ All SnapTest Generators</div>
              <div className="features">
                <div className="new">+ Auto-saving</div>
                <div className="new">+ Syncing cross devices</div>
                <div className="new construct">+ Test Archiving</div>
                <div className="new construct">+ Persistence of results</div>
                <div className="new construct">+ Cloud execution of tests</div>
              </div>
              <div className="grid-item"></div>
              <div className="price">
                <div>$14.99/month</div>
                <button className="pt-button pt-intent-primary2 pt-large" onClick={() => this.props.history.push(Paths.PREMIUM)} >
                  + Get Cloud
                </button>
              </div>
            </div>
          </div>
          <div className="grid-item grid-row card sr4 full-s5">
            <div className="grid-item feature-plan grid-row grid-column team">
              <div className="title">Teams</div>
              <div className="core">SnapTest Tool</div>
              <div className="core">SnapTest Generators</div>
              <div className="features">
                <div className="new">+ Shared account</div>
                <div className="new">+ Projects</div>
                <div className="new">+ 3 seats ($69.99 per additional seat)</div>
                <div className="new">+ Team collaboration features</div>
                <div className="new construct">+ Audit log</div>
                <div className="new construct">+ Projects overview dashboard</div>
              </div>
              <div className="grid-item"></div>
              <div className="price">
                <div>$360/month</div>
                <button className="pt-button pt-intent-primary3 pt-large" onClick={() => this.props.history.push(Paths.TEAMS)}>
                  + Create Team
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
        <Footer />
      </div>
    )
  }

}

export default Pricing;



// WEBPACK FOOTER //
// ./src/pages/pricing.js